module.exports = __webpack_public_path__ + "static/TT2-evergreen-page-screening-sales-move-iStock-1189130077.14f9af55.jpg";